export default "__VITE_ASSET__BV4Fs4dl__"